// extracted by mini-css-extract-plugin
module.exports = {"sender":"SAnjprZi0X4TLgknsidaS","timeSent":"_1V_jG5cF80MPCSiNs8o-mf"};